// export const FETCH_USERPROFILEDATA_REQUEST =
//   "FETCH_USERPROFILEDATA_REQUEST";
// export const FETCH_USERPROFILEDATA_SUCCESS =
//   "FETCH_USERPROFILEDATA_SUCCESS";
// export const FETCH_USERPROFILEDATA_FAILURE =
//   "FETCH_USERPROFILEDATA_FAILURE";
export const FETCH_USERPROFILEDATA_REQUEST = "FETCH_USERPROFILEDATA_REQUEST";
export const FETCH_USERPROFILEDATA_SUCCESS = "FETCH_USERPROFILEDATA_SUCCESS";
export const FETCH_USERPROFILEDATA_FAILURE = "FETCH_USERPROFILEDATA_FAILURE";

export const CREATE_USERPROFILE_REQUEST = "CREATE_USERPROFILE_REQUEST";
export const CREATE_USERPROFILE_SUCCESS = "CREATE_USERPROFILE_SUCCESS";
export const CREATE_USERPROFILE_FAILURE = "CREATE_USERPROFILE_FAILURE";

export const UPDATE_USERPROFILE_REQUEST = "UPDATE_USERPROFILE_REQUEST";
export const UPDATE_USERPROFILE_SUCCESS = "UPDATE_USERPROFILE_SUCCESS";
export const UPDATE_USERPROFILE_FAILURE = "UPDATE_USERPROFILE_FAILURE";

export const DELETE_USERPROFILE_REQUEST = "DELETE_USERPROFILE_REQUEST";
export const DELETE_USERPROFILE_SUCCESS = "DELETE_USERPROFILE_SUCCESS";
export const DELETE_USERPROFILE_FAILURE = "DELETE_USERPROFILE_FAILURE";
